// extracted by mini-css-extract-plugin
export default {"main":"Fda-z"};